import { resolveTenantSlug } from './resolveTenantSlug'
import { createContext, useContext, useMemo } from 'react'
import type { ReactNode } from 'react'

const TenantContext = createContext<string | null>(null)

interface TenantProviderProps {
  children: ReactNode
}

export const TenantProvider = ({ children }: TenantProviderProps) => {
  const slug = useMemo(() => resolveTenantSlug(), [])
  return (
    <TenantContext.Provider value={slug}>{children}</TenantContext.Provider>
  )
}

export const useTenant = (): string | null => useContext(TenantContext)
